import { CCTVMAP } from "../../actions/dashboard";

export default function(state = [], action) {
  switch (action.type) {
    case CCTVMAP:
      return action.payload;
    default:
  }
  return state;
}
